"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandleTooltip = void 0;
var react_1 = __importStar(require("react"));
var raf_1 = __importDefault(require("rc-util/lib/raf"));
var Tooltip_1 = __importDefault(require("../../Tooltip/Tooltip"));
var HandleTooltip = function (props) {
    var value = props.value, children = props.children, visible = props.visible, valueSuffix = props.valueSuffix, restProps = __rest(props, ["value", "children", "visible", "valueSuffix"]);
    var tooltipRef = react_1.default.useRef();
    var rafRef = react_1.default.useRef(null);
    var cancelKeepAlign = function () {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        raf_1.default.cancel(rafRef.current);
    };
    var keepAlign = function () {
        rafRef.current = raf_1.default(function () {
            var _a;
            (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.forceAlign();
        });
    };
    react_1.useEffect(function () {
        if (value) {
            keepAlign();
        }
        else {
            cancelKeepAlign();
        }
        return cancelKeepAlign;
    }, [value]);
    return (react_1.default.createElement(Tooltip_1.default, __assign({ overlay: "" + value + valueSuffix, ref: tooltipRef }, restProps, (visible === undefined ? {} : { visible: visible })), children));
};
exports.HandleTooltip = HandleTooltip;
exports.default = exports.HandleTooltip;
